export const API_URL = "https://api.goshy.digital";
export const CLOUDFLARE_TURNSTILE_SITEKEY = "0x4AAAAAAAMVSakIeP3P-EEH";
export const CLOUDFLARE_TURNSTILE_CHECKOUT_SITEKEY = "0x4AAAAAAAMVSakIeP3P-EEH";
export const TELEGRAM_CHANNEL_URL = "https://t.me/TopAlerts";
export const LOGO_URL = "https://i.imgur.com/EqAoJKF.png";
export const STORE_NAME = "TopAlts";
export const TELEGRAM_SUPPORT_BOT_USERNAME = "TopAltsSupport_Bot";